const PERIOD_OPTIONS = [
  { id: 'day', name: 'Dias' },
  { id: 'month', name: 'Meses' },
  { id: 'year', name: 'Anos' },
]

const FREQUENCY_OPTIONS = [
  { id: 'daily', name: 'Diária' },
  { id: 'weekly', name: 'Semanal' },
  { id: 'monthly', name: 'Mensal' },
]

const DIALOG_CHANGE_STATUSES = {
  false: 'Tem certeza que deseja ativar este serviço?',
  true: 'Tem certeza que deseja inativar este serviço? A partir do momento que inativar, não será mais possível vinculá-lo aos serviços do contrato.',
}

const DESTROY_DIALOG =
  'Tem certeza que deseja excluir este serviço? Esta ação é irreversível e os contratos que utilizam este serviço perderão o vínculo com ele.'

const paymentServiceTemplate = {
  PERIOD_OPTIONS,
  FREQUENCY_OPTIONS,
  DIALOG_CHANGE_STATUSES,
  DESTROY_DIALOG,
}

export default paymentServiceTemplate
